// The values of these keys equate to how a given feature flag is referenced throughout the CNP code base.
// This is helpful in cases such as a disabled feature flag, where Amplitude will not provide the flag, but where our code base may reference it (and we want it defaulted to false)
export enum GraceFeatureFlags {
    // Feature Flag Enum Name = "Feature Flag Name",
    AnnotatorServiceReactUtterances = 'annotatorServiceRedactUtterances',
    ChatbotConfigInputCharacterCountLimit = 'chatbotConfigInputCharacterCountLimit',
    ChatbotConfigInputCharWarningThreshold = 'chatbotConfigInputCharWarningThreshold',
    DirectLineReconnect = 'directLineReconnect',
    DirectLineReconnectLocal = 'directLineReconnectLocal',
    EnableFulfillmentOptionWithDearDoctor = 'enableFulfillmentOptionWithDearDoctor',
    Feedback = 'feedback',
    FinancialAssistanceCalculator = 'financialAssistanceCalculator',
    FinAssistanceApplyOnline = 'finAssistanceApplyOnline',
    FinCalculator = 'finCalculator',
    FlowGpt2FAEnabled = 'flowGpt2FAEnabled',
    FlowGptAlertsMentalHealthEnabled = 'flowGptAlertsMentalHealthEnabled',
    FlowGPTEnabled = 'flowGptEnabled',
    FlowGPTFinCalculatorEnabled = 'flowGptFinCalculatorEnabled',
    FlowGptLoginRelatedEnabled = 'flowGptLoginRelatedEnabled',
    GenesysDynamicConfigurationValue = 'genesysDynamicConfigurationValue',
    InferRegionFromDomain = 'inferRegionFromDomain',
    LiveChatRevCycleEnabled = 'liveChatRevCycleEnabled',
    LiveChatRevCycleOpen = 'liveChatRevCycleOpen',
    LLMContextualOutOfScopeResponse = 'llmContextualOutOfScopeResponse',
    LLMContextualOutOfScopeResponseShadowMode = 'llmContextualOutOfScopeResponseShadowMode',
    LLMEmergencyAudit = 'llmEmergencyAudit',
    LLMGreenYellowRedAudit = 'llmGreenYellowRedAudit',
    LLMRefineResponse = 'llmRefineResponse',
    LLMRefineResponseShadowMode = 'llmRefineResponseShadowMode',
    MessageAssistCategoricalExperience = 'messageAssistCategoricalExperience',
    MessageAssistEnablePostFulfillmentSurvey = 'messageAssistEnablePostFulfillmentSurvey',
    MessageAssistEnablePostSendMessageSurvey = 'messageAssistEnablePostSendMessageSurvey',
    MessageAssistGreetingOptimization = 'messageAssistGreetingOptimization',
    MessageAssistIAmABot = 'messageAssistIAmABot',
    MessageAssistMedicallyActionable = 'messageAssistMedicallyActionable',
    MessageAssistTestResultsQuestionFlow = 'messageAssistTestResultsQuestionFlow',
    MessageAssistTestResultsSearchFlow = 'messageAssistTestResultsSearchFlow',
    MultipleProviderMessaging = 'multipleProviderMessaging',
    MyChartBillingPilotEnabled = 'myChartBillingPilotEnabled',
    OmitAskUserLocationOnStart = 'omitAskUserLocationOnStart',
    Outage = 'outage',
    QuestionAboutTestResults = 'questionAboutTestResults',
    RasaAnnotatorServiceMode = 'rasaAnnotatorServiceMode',
    RasaAnnotatorTrainOfThought = 'rasaAnnotatorTrainOfThought',
    RasaCalmChangeMedicationEnabled = 'rasaCalmChangeMedicationEnabled',
    RasaCalmMedicationRefillEnabled = 'rasaCalmMedicationRefillEnabled',
    RasaCalmNewMedicationEnabled = 'rasaCalmNewMedicationEnabled',
    RasaDisambiguationConfidenceScore = 'rasaDisambiguationConfidenceScore',
    RequestForReferralsEnabled = 'requestForReferralsEnabled',
    SearchForTestResults = 'searchForTestResults',
    ShowMaSendConfirmation = 'showMaSendConfirmation',
    SymptomCheckerEnabled = 'symptomCheckerEnabled',
    UseMyChartAuthPages = 'useMyChartAuthPages',
}

// NAMING CONVENTION: feature flags from amplitude should be lower case and kebab case like
// amplitude-migration-enabled
export enum LookUpFromAmplitudeFeatureFlagNameToCNPKey {
    'annotator-service-redact-utterances' = 'AnnotatorServiceReactUtterances',
    'chatbotconfig-inputcharcountlimit' = 'ChatbotConfigInputCharacterCountLimit',
    'chatbotconfig-inputcharwarningthreshold' = 'ChatbotConfigInputCharWarningThreshold',
    'direct-line-reconnect-local' = 'DirectLineReconnectLocal',
    'direct-line-reconnect' = 'DirectLineReconnect',
    'enable-fulfillment-option-with-dear-doctor' = 'EnableFulfillmentOptionWithDearDoctor',
    'feedback' = 'Feedback',
    'fin-calculator' = 'FinCalculator',
    'financial-assistance-calculator' = 'FinancialAssistanceCalculator',
    'finassistanceapplyonline' = 'FinAssistanceApplyOnline',
    'flow-gpt-enabled' = 'FlowGPTEnabled',
    'flowgpt2faenabled' = 'FlowGpt2FAEnabled',
    'flowgptalertsmentalhealthenabled' = 'FlowGptAlertsMentalHealthEnabled',
    'flowgptfincalculatorenabled' = 'FlowGPTFinCalculatorEnabled',
    'flowgptloginrelatedenabled' = 'FlowGptLoginRelatedEnabled',
    'genesys-dynamic-configuration-value' = 'GenesysDynamicConfigurationValue',
    'infer-region-from-domain' = 'InferRegionFromDomain',
    'live-chat-rev-cycle-enabled' = 'LiveChatRevCycleEnabled',
    'live-chat-rev-cycle-open' = 'LiveChatRevCycleOpen',
    'llm-contextual-out-of-scope-response-shadow-mode' = 'LLMContextualOutOfScopeResponseShadowMode',
    'llm-contextual-out-of-scope-response' = 'LLMContextualOutOfScopeResponse',
    'llm-emergency-audit' = 'LLMEmergencyAudit',
    'llm-green-yellow-red-audit' = 'LLMGreenYellowRedAudit',
    'llm-refine-response-shadow-mode' = 'LLMRefineResponseShadowMode',
    'llm-refine-response' = 'LLMRefineResponse',
    'message-assist-categorical-experience' = 'MessageAssistCategoricalExperience',
    'message-assist-enable-post-fulfillment-survey' = 'MessageAssistEnablePostFulfillmentSurvey',
    'message-assist-enable-post-send-message-survey' = 'MessageAssistEnablePostSendMessageSurvey',
    'message-assist-greeting-optimization' = 'MessageAssistGreetingOptimization',
    'message-assist-i-am-a-bot' = 'MessageAssistIAmABot',
    'message-assist-medically-actionable' = 'MessageAssistMedicallyActionable',
    'message-assist-test-results-question-flow' = 'MessageAssistTestResultsQuestionFlow',
    'message-assist-test-results-search-flow' = 'MessageAssistTestResultsSearchFlow',
    'multiple-provider-messaging' = 'MultipleProviderMessaging',
    'mychart-billing-pilot-enabled' = 'MyChartBillingPilotEnabled',
    'omit-ask-user-location-on-start' = 'OmitAskUserLocationOnStart',
    'outage' = 'Outage',
    'question-about-test-results' = 'QuestionAboutTestResults',
    'rasa-annotator-train-of-thought' = 'RasaAnnotatorTrainOfThought',
    'rasa-calm-change-medication-enabled' = 'RasaCalmChangeMedicationEnabled',
    'rasa-calm-medication-refill-enabled' = 'RasaCalmMedicationRefillEnabled',
    'rasa-calm-new-medication-enabled' = 'RasaCalmNewMedicationEnabled',
    'rasa-disambiguation-confidence-score' = 'RasaDisambiguationConfidenceScore',
    'request-for-referrals-enabled' = 'RequestForReferralsEnabled',
    'search-for-test-results' = 'SearchForTestResults',
    'show-ma-send-confirmation' = 'ShowMaSendConfirmation',
    'symptom-checker-enabled' = 'SymptomCheckerEnabled',
    'use-mychart-auth-pages' = 'UseMyChartAuthPages',
}
